import React, { FC, useMemo } from "react";
import ReactDOM from "react-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import { NOTIFICATIONS } from "~/constans/notifications";
import {
  useGetNotificationsQuery,
  useUpdateNotificationMutation,
} from "~/schemas/generated/graphql";

import Notification from "./Notification";

import s from "./styles.less";

const NotificationsMessage: FC = () => {
  const {
    data: { getNotifications },
  } = useGetNotificationsQuery();
  const [updateNotificationMutation] = useUpdateNotificationMutation({});

  const notifications = useMemo(() => {
    return getNotifications.filter(
      ({ type, isOpen }) => type !== NOTIFICATIONS.report && isOpen,
    );
  }, [getNotifications]);

  const notificationHide = (id): void => {
    updateNotificationMutation({
      variables: {
        id,
        isOpen: false,
      },
    });
  };

  return ReactDOM.createPortal(
    <>
      <TransitionGroup className={s.notifications_message}>
        {notifications.map(({ id, isOpen, type, content, duration }) => (
          <CSSTransition
            key={id}
            timeout={600}
            classNames={{
              enter: s["notification_message-enter"],
              enterActive: s["notification_message-enter-active"],
              exit: s["notification_message-exit"],
              exitActive: s["notification_message-exit-active"],
            }}
          >
            <Notification
              key={id}
              type={type}
              content={content}
              duration={duration}
              actionClose={() => notificationHide(id)}
            />
          </CSSTransition>
        ))}
      </TransitionGroup>
    </>,
    document.getElementById("notifications"),
  );
};

export default NotificationsMessage;
